export default __webpack_public_path__ + "static/media/image5.a3c51719.jpg";